export default __webpack_public_path__ + "81438e0d20562ed29f1576dcd36c4047.svg";